// import Course from '@/page/Course.vue'
const Topiclibraryview = resolve =>require(['@/page/Topiclibraryview.vue'], resolve)

export default {
  path: '/home/sharetopiclibraryview',
  component: Topiclibraryview,
  meta:{
    title: '共享试题库',
    path:'/home/sharetopiclibrary'
  }
}



// WEBPACK FOOTER //
// ./src/router/sharetopiclibraryview.js